import React from 'react';
import { PulseLoader } from 'halogenium';
import './loader.css';

class LoaderView extends React.Component {
  render() {
    return (
      <PulseLoader loading={this.props.loading || false} className="loader" color="#3b3b3b" size="16px"/>
    );
  }
}

export default LoaderView;
